import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  IonicModule,
  ModalController,
  NavParams,
  ToastController
} from '@ionic/angular';
import { Subscription } from 'rxjs';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';
import { ForbrukService } from '../../../services/forbruk/forbruk.service';
import { Anlegg } from '../../../services/forbruk/forbruk.types';
import AirDatepicker from 'air-datepicker';
import { CustomLocaleNb } from 'src/app/utils/date-utils';
import { addYears } from 'date-fns';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-download-forbruk-popup',
  templateUrl: './download-forbruk-popup.page.html',
  styleUrls: ['./download-forbruk-popup.page.scss', '../forbruk.page.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule, FormsModule]
})
export class DownloadForbrukPopupPage implements OnInit, OnDestroy {
  dataobject: any;
  anleggList: Anlegg[];
  valgtAnlegg: Anlegg;
  _showAnleggsliste: boolean;

  Datepicker: AirDatepicker<HTMLElement>;

  epost: string;
  maxDate: Date;
  minDate: Date;

  selectedDate1: Date;
  selectedDate2: Date;
  selectedDate3: Date;

  mode: number;

  showConfirmation = false;
  hasClickedExport = false;
  selectedDate: Date;

  forbrukSubscription: Subscription;

  constructor(
    public modalCtrl: ModalController,
    private _toast: ToastController,
    public navParams: NavParams,
    public forbrukService: ForbrukService,
    private analyticsService: AnalyticsService
  ) { }

  ngOnInit() {
    this.dataobject = this.navParams.data;

    this._showAnleggsliste = this.dataobject[9];

    this.anleggList = this.dataobject[0];
    this.valgtAnlegg = this.dataobject[1];
    this.mode = this.dataobject[2];

    this.selectedDate1 = this.dataobject[3];
    this.selectedDate2 = this.dataobject[4];
    this.selectedDate3 = this.dataobject[5];

    this.maxDate = this.dataobject[6];
    this.minDate = this.dataobject[7];
    this.epost = this.dataobject[8];

    if (this.mode == 0) {
      this.selectedDate = this.maxDate;
    }
    if (this.mode == 1) {
      this.selectedDate = this.selectedDate1;
    }
    if (this.mode == 2) {
      this.selectedDate = this.selectedDate2;
    }

    if (this.mode == 3) {
      this.selectedDate = this.selectedDate3;
    }
  }

  ngOnDestroy(): void {
    this.forbrukSubscription?.unsubscribe();
  }

  ngAfterViewInit() {
    this.Datepicker = new AirDatepicker('#airDownload0', {
      startDate: this.selectedDate,
      locale: CustomLocaleNb,
      maxDate: this.maxDate,
      minDate: this.minDate,
      range: false,
      toggleSelected: false,
      view: 'months',
      minView: 'months',
      autoClose: true,
      dateFormat: 'MMMM yyyy',
      visible: false,
      onSelect: function(date: Date) {
        if (date['formattedDate']) {
          this.selectedDate = date['date'];
        }
      }.bind(this)
    });
    this.Datepicker.selectDate(this.selectedDate);
  }

  anleggChanged() {
    const toDate = new Date(this.valgtAnlegg.tildato);
    const fromDate = new Date(this.valgtAnlegg.fradato);
    this.maxDate = toDate > new Date() ? new Date() : toDate;
    const twoYearsEarlier = addYears(this.maxDate, -2);
    this.minDate = fromDate > twoYearsEarlier ? fromDate : twoYearsEarlier;
    this.Datepicker.update({
      maxDate: this.maxDate,
      minDate: this.minDate
    });
    this.Datepicker.selectDate(this.maxDate);
  }

  public closeModal() {
    this.modalCtrl.dismiss({
      dismissed: true
    });
  }

  async sendExcel() {
    this.hasClickedExport = true;

    this.analyticsService.logEvent_selectContent(
      'forbruk nedlasting til excel'
    );

    //curl -k -X POST -H "Authorization: Bearer {token}" -H "Content-type: application/json" -d
    //'{"aar":2020, "mnd": 11, "objectid": "1234", "epostadresse": "morten.hansen@ishavskraft.no"}' https://apiprivat.ishavskraft.no/forbruk/forbruksdetaljer

    // TODO: Check `mnd` type, if string - ok with one character?
    const payload = JSON.stringify({
      aar: this.selectedDate.getFullYear(),
      mnd: this.selectedDate.getMonth() + 1,
      objectid: this.valgtAnlegg.objectid,
      epostadresse: this.epost
    });

    this.forbrukSubscription = this.forbrukService
      .getExcelfil(payload)
      .subscribe({
        next: async (response) => {
          if (response.message && response.message == 'ok') {
            this.showConfirmation = true;
          } else {
            await this._toast
              .create({
                message: 'En feil oppsto',
                duration: 2000,
                position: 'middle',
                color: 'danger'
              })
              .then((toast) => {
                toast.present();
              });
          }
        },
        error: async (err) => {
          await this._toast
            .create({
              message: 'En feil oppsto',
              duration: 2000,
              position: 'middle',
              color: 'danger'
            })
            .then((toast) => {
              toast.present();
            });
        }
      });

    //await 4 sec
    await this.delay(4000);
  }

  delay(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  anleggIsInactive(anlegg: Anlegg) {
    return anlegg.tildato ? new Date(anlegg.tildato) < new Date() : false;
  }
}
